import routes from "modules/reportes/routes";
import { chartsGenerator } from "./generator";

export default chartsGenerator(routes);
